/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityarchetypelabelcreator3Inputs */



/**
* | output |
* | --- |
* | "The Vibe Creator" |
*
* @param {Personalityarchetypelabelcreator3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityarchetypelabelcreator3 = /** @type {((inputs?: Personalityarchetypelabelcreator3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityarchetypelabelcreator3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The Vibe Creator")
	if (locale === "es") return /** @type {LocalizedString} */ ("El Creador de Buenas Vibras")
	return /** @type {LocalizedString} */ ("Создатель вайба")
});
export { personalityarchetypelabelcreator3 as "personalityArchetypeLabelCreator" }